import { MCO_DOMAIN } from '@/libs/constant';
import { T } from '@/libs/translation';
import { Icon, Typo } from '@/ui/component/atom';
import { Layout } from '@/ui/component/cell';
import { getSharedData } from '@/ui/util';
import { entries, filter, map, pipe, toArray } from '@fxts/core';
import { html, type Html, Page } from 'rune-ts';
import { PostMessage } from '../../../util/postMessage';
import klass from './Error.module.scss';

export interface ErrorPageData {}

export class ErrorPage extends Page<ErrorPageData> {
  protected override template(): Html {
    const { theme, is_app } = getSharedData(this);

    return html`
      <div>
        ${new Layout({
          view: html` <div class="${klass.page}">
            <div class="${klass.logo}">
              ${new Icon({
                name: 'mco_logo',
                size: 80,
              })}
            </div>
            <div class="${klass.guide}">${new Typo({ text: html.preventEscape(T('error.guide')) })}</div>
            <div class="${klass.services}">
              ${pipe(
                MCO_DOMAIN,
                entries,
                filter(([key]) => {
                  if (is_app) {
                    return theme === key;
                  }
                  return true;
                }),
                map(([service_name, domain]) => {
                  return html`
                    <a class="${klass.item} ${service_name}" href="${domain}">
                      <div data-theme="${service_name}" class="${klass.logo}">
                        ${new Icon({
                          name: 'logo_mini',
                          theme: service_name,
                          size: service_name === 'Ciety' ? 28 : service_name === 'MarppleShop' ? 21 : 15,
                        })}
                      </div>
                      <div class="${klass.text}">
                        ${new Typo({ text: T('common.service_description', { context: service_name }) })}
                        ${new Typo({ text: T('common.service', { context: service_name }) }, { weight: 'bold' })}
                      </div>
                    </a>
                  `;
                }),
                toArray,
              )}
            </div>
          </div>`,
        })}
      </div>
    `;
  }

  override onRender() {
    const { app_info } = getSharedData(this);

    if (app_info?.name === 'MarppleShop') {
      this.delegate('click', '.MarppleShop', (e) => {
        e.originalEvent.preventDefault();
        PostMessage.goHome();
      });
    }
  }
}
